import type { VoidComponent } from "solid-js";
import TourModal from "../../components/modal/TourModal";
import { useTranslation } from "../../state/i18n";
import { useLocalUserSettings, useLocalUserSettingsDispatch } from "../../state/localUserSettings";
import { DECORATIVE_IMAGE_ALT } from "../../constants";
import tourIntroImage from "../../assets/new-platform-tour.webp";

const NewPlatformTourModal: VoidComponent = () => {
  const { t } = useTranslation();
  const settings = useLocalUserSettings();
  const setLocalUserSettings = useLocalUserSettingsDispatch();

  const dismiss = () => setLocalUserSettings("dismissedNewPlatformTour", true);

  return (
    <TourModal
      open={!(settings.dismissedNewPlatformTour ?? false)}
      image={{ src: tourIntroImage, alt: DECORATIVE_IMAGE_ALT }}
      title={t(($) => $.NEW_PLATFORM_TOUR_TITLE)}
      description={t(($) => $.NEW_PLATFORM_TOUR_DESCRIPTION)}
      onClose={dismiss}
      primaryAction={{
        label: t(($) => $.NEW_PLATFORM_TOUR_PRIMARY_BUTTON),
        onClick: dismiss,
      }}
      secondaryAction={{
        label: t(($) => $.NEW_PLATFORM_TOUR_SECONDARY_BUTTON),
        onClick: () => {
          window.open(
            t(($) => $.NEW_PLATFORM_TOUR_SECONDARY_BUTTON_LINK),
            "_blank",
          );
        },
      }}
    />
  );
};

export default NewPlatformTourModal;
